import React from 'react';
import { Box } from '@mui/material';

export default function ResponderLayout({ children }) {
  return (
    <Box
      component="main"
      sx={{ 
        flexGrow: 1, 
        px: { xs: 0, md: 3 },
        pt: 0,
        pb: 2
      }}
    >
      {children}
    </Box>
  );
}